module.exports = __webpack_public_path__ + "img/cg3.39dc4495.jpg";